var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypefilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.3a.7.7 0 0 1 .627.39l2.928 5.93 6.546.957a.7.7 0 0 1 .387 1.194l-4.736 4.614 1.118 6.517a.7.7 0 0 1-1.016.738L12 18.56l-5.854 3.08a.7.7 0 0 1-1.016-.738l1.118-6.517L1.51 9.77A.7.7 0 0 1 1.9 8.578l6.546-.956 2.927-5.93A.7.7 0 0 1 12 1.3Z",
  fill: "currentColor"
})));
export { SvgTypefilled as ReactComponent };
export default __webpack_public_path__ + "d3dad403e5d731447cbc7683cfe2f166.svg";